import { RefObject, useEffect } from "react";

interface Props {
    tableWrapperRef: RefObject<HTMLDivElement | null>;
    tableRef: RefObject<HTMLTableElement | null>;
    setHeaderWidth: (value: number) => void;
    setHeaderLeft: (value: number) => void;
    setHeaderHeight: (value: number) => void;
    setFirstColumnWidth: (value: number) => void;
}

export default function useTableDimensions({ tableWrapperRef, tableRef, setHeaderWidth, setHeaderLeft, setHeaderHeight, setFirstColumnWidth, }: Props) {
    useEffect(() => {
        const tableWrapper = tableWrapperRef.current;
        const table = tableRef.current;

        if (!tableWrapper || !table) {
            return;
        }

        const updateDimensions = () => {
            const wrapperRect = tableWrapper.getBoundingClientRect();

            setHeaderWidth(wrapperRect.width);
            setHeaderLeft(wrapperRect.left);

            const firstHeaderCell =
                table.querySelector(
                    "thead tr th:first-child"
                ) as HTMLElement | null;

            if (firstHeaderCell) {
                setFirstColumnWidth(
                    firstHeaderCell.getBoundingClientRect().width
                );

                setHeaderHeight(
                    firstHeaderCell.getBoundingClientRect().height
                );
            }
        };

        updateDimensions();

        const resizeObserver =
            new ResizeObserver(updateDimensions);

        resizeObserver.observe(tableWrapper);
        resizeObserver.observe(table);

        return () => {
            resizeObserver.disconnect();
        };
    }, [
        tableWrapperRef,
        tableRef,
        setHeaderWidth,
        setHeaderLeft,
        setHeaderHeight,
        setFirstColumnWidth,
    ]);
}